import { render } from "./login.vue?vue&type=template&id=672bc96b"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/auth/login.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "672bc96b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('672bc96b', __exports__)) {
    console.log('reload')
    api.reload('672bc96b', __exports__)
  }
  
  module.hot.accept("./login.vue?vue&type=template&id=672bc96b", () => {
    console.log('re-render')
    api.rerender('672bc96b', render)
  })

}


export default __exports__